<template>
    <div class="Login container-fluid">

        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-5 col-xl-3 text-center">
                <div v-if="showError" class="shadow white bg-white rounded-10 p-4 mt-4">

                    <!-- Form -->
                    <h1>{{ $t('resetPassword.resetFailed') }}</h1>

                    <p>{{ $t('resetPassword.resetFailedExplanation') }}</p>

                    <router-link :to="{ name: 'ForgotPassword' }" class="">{{ $t('resetPassword.clickHereTryAgain') }}</router-link>

                </div>
                <div v-else-if="!showConfirmation" class="shadow white bg-white rounded-10 p-4 mt-4">

                    <!-- Form -->
                    <h1>{{ $t('resetPassword.resetPassword') }}</h1>

                    <p>{{ $t('resetPassword.enterPassword') }}</p>

                    <password-fields v-model="ResetModel"></password-fields>

                    <div class="mt-4">
                        <navigation-button mode="custom"  busy-icon="three-dots" animation="cylon" :allow-press="ResetModel.PasswordValid && ResetModel.PasswordsMatch" :text="$t('general.submit')" @button-clicked="SubmitForm()"></navigation-button>
                    </div>

                    {{MethodResponse}}

                </div>
                <div v-else-if="showConfirmation" class="shadow white bg-white rounded-10 p-4 mt-4">

                    <!-- Form -->
                    <h1>{{ $t('resetPassword.resetSuccessful') }}</h1>

                    <p>{{ $t('resetPassword.loginAndRedirectPending') }}</p>

                    <router-link :to="{ name: 'DashboardHome' }" class="">{{ $t('confirmEmail.forceRedirect') }}</router-link>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
	import NavigationButton from "@/private/components/UI-elements/NavigationButton.vue";
	import PasswordFields from '@/public/components/Account/PasswordFields.vue'

    export default {
        name: 'ResetPassword',
        components: {
            NavigationButton,
			PasswordFields
        },
        props: {

        },
        data: function () {

            return {
                ResetModel: {
                    UserID: '',
                    Password: '',
					ConfirmPassword: '',
                    Code: '',
					PasswordsMatch: false,
					PasswordValid: false,
                },
                MethodResponse: '',
                showConfirmation: false,
				showError: false,
				lstErrors: []
            }

        },
        mounted: function () {
            this.ResetModel.Code = this.$route.query.code
			this.ResetModel.UserID = this.$route.query.userID
        },
        methods: {
            SubmitForm: function () {

                axios({
                    method: 'post',
					url: '/account/ResetPassword',
					data: this.ResetModel
                })
                    .then((response) => {

                        if (response.data.succeeded) {
                            this.showConfirmation = true

                            //Force check for login status
                            this.$store.commit('SET_loginStatusActual', false)

                            setTimeout(() => {
                                
								
								this.$router.push({ name: 'DashboardHome' })
							}, 3000);


                        } else {
                            this.showError = true
                            this.lstErrors = response.data.errors
                        }

                        this.MethodResponse = response.data;
                    })
                    .catch((error) => {
                        this.MethodResponse = error;
                    });
            }
        },
        computed: {
   
        }
    }
</script>
